import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const calorieTrackingApp = useStore((state) => state.calorieTrackingApp);
  const setCalorieTrackingApp = useStore((state) => state.setCalorieTrackingApp);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.calorieTrackingApp.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={calorieTrackingApp}
          onChange={(value) => {
            setCalorieTrackingApp(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'calorie-tracking-app',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"Yazio"}>
            <span>🍏</span> {t('onboarding.calorieTrackingApp.options.yazio')}
          </Option>
          <Option value={"MyFitnessPal"}>
            <span>🔵</span> {t('onboarding.calorieTrackingApp.options.myFitnessPal')}
          </Option>
          <Option value={"Lifesum"}>
            <span>💛</span> {t('onboarding.calorieTrackingApp.options.lifesum')}
          </Option>
          <Option value={"LoseIt!"}>
            <span>🟠</span> {t('onboarding.calorieTrackingApp.options.loseIt')}
          </Option>
          <Option value={"WW (Weight Watchers)"}>
            <span>🟢</span> {t('onboarding.calorieTrackingApp.options.weightWatchers')}
          </Option>
          <Option value={"Noom"}>
            <span>🧠</span> {t('onboarding.calorieTrackingApp.options.noom')}
          </Option>
          <Option value={"FatSecret"}>
            <span>🥗</span> {t('onboarding.calorieTrackingApp.options.fatSecret')}
          </Option>
          <Option value={"Other"}>
            <span>❓</span> {t('onboarding.calorieTrackingApp.options.other')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
